import { render, staticRenderFns } from "./ProductCardSmall.vue?vue&type=template&id=4b5b0c34&scoped=true&"
import script from "./ProductCardSmall.vue?vue&type=script&lang=js&"
export * from "./ProductCardSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b0c34",
  null
  
)

export default component.exports